import React from 'react';
import { IInputProps } from '../input';
import Tooltip from '../../tooltip';
import { RichText } from '../..';
export const InputLabel = ({
	ariaLabel,
	label,
	required,
	errors,
	name,
	help,
	className,
}: IInputProps) => {
	return (
		<>
			{(label || help) && (
				<div className="flex items-center">
					{label && (
						<label
							aria-label={ariaLabel}
							htmlFor={name}
							className={'text-lg text-font flex items-center ' + (className ?? '')}>
							{typeof label === 'string' ? <RichText html={label} /> : label}
						</label>
					)}
					{help && (
						<Tooltip className="ml-2" fieldname={name}>
							<RichText html={help} />
						</Tooltip>
					)}
				</div>
			)}
		</>
	);
};
